const EXPERIENCE_CART_KEY = 'experience-cart';
const LEGACY_CART_PREFIX = 'experience-cart-';
const PENDING_CHECKOUT_PREFIX = 'pendingExperienceBulkCheckoutId-';

export const clearExperienceCart = () => {
    localStorage.removeItem(EXPERIENCE_CART_KEY);
    Object.keys(localStorage)
        .filter(key => key.startsWith(LEGACY_CART_PREFIX) || key.startsWith(PENDING_CHECKOUT_PREFIX))
        .forEach(key => localStorage.removeItem(key));
};
